<template>
  <div class="flex-box">
    <div class="search-box">
      <div>
        <label class="searchItemName">渠道：</label>
        <el-select v-model="queryParams.channelId" clearable placeholder="筛选渠道">
          <el-option v-for="item in channels" :key="item.id" :label="item.channelName" :value="item.id"></el-option>
        </el-select>
      </div>
      <div>
        <label class="searchItemName">设备号：</label>
        <el-input class="input-box" placeholder="设备编号" v-model="queryParams.deviceCode" clearable
          @keyup.enter.native="search()"></el-input>
      </div>
      <div>
        <label class="searchItemName" style="width: 110px;">拍照人姓名：</label>
        <el-input class="input-box" placeholder="姓名" v-model="queryParams.idName" clearable
          @keyup.enter.native="search()"></el-input>
      </div>
      <div>
        <label class="searchItemName" style="width: 120px;">证件号后6位：</label>
        <el-input class="input-box" placeholder="证件号后6位" v-model="queryParams.idNumber" clearable maxlength="6" style="width: 150px;"
          @keyup.enter.native="search()"></el-input>
      </div>
      <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="search()">查询</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%; margin: 15px 0;">
      <el-table-column prop="deviceCode" label="设备编号" width="140" align="center"></el-table-column>
      <el-table-column prop="channelName" label="渠道名称" width="160" align="center"></el-table-column>
      <el-table-column label="证件信息" width="180" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.idName }}</div>
          <div>{{ maskIdNumber(scope.row.idNumber) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="sex" label="性别" width="80" align="center"></el-table-column>
      <el-table-column prop="photoTypeName" label="相片类型" width="120" align="center"></el-table-column>
      <el-table-column prop="createTime" label="拍照时间" width="170" align="center"></el-table-column>
      <el-table-column label="支付状态" width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.payStatus === 0 ? 'info' : (scope.row.payStatus === 1 ? 'success' : '')">
            {{ scope.row.payStatus === 0 ? '未支付' : (scope.row.payStatus === 1 ? '支付成功' : '免费') }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="orderId" label="支付订单ID" width="120" align="center"></el-table-column>
      <el-table-column label="操作" align="center" min-width="120">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" plain @click="openDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="queryParams.pageIndex" :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next" :total="total">
    </el-pagination>
    <el-dialog title="拍照详情" :visible.sync="dialogVisible" width="520px">
      <div v-if="detail.photo" style="text-align: center; margin-bottom: 16px;">
        <img :src="detail.photo" alt="相片" style="max-width: 100%; max-height: 280px;" />
      </div>
      <el-form label-width="90px">
        <el-form-item label="姓名">{{ detail.idName }}</el-form-item>
        <el-form-item label="证件号">{{ maskIdNumber(detail.idNumber) }}</el-form-item>
        <el-form-item label="性别">{{ detail.sex }}</el-form-item>
        <el-form-item label="相片类型">{{ detail.photoTypeName }}</el-form-item>
        <el-form-item label="设备">{{ detail.deviceCode }}</el-form-item>
        <el-form-item label="渠道">{{ detail.channelName }}</el-form-item>
        <el-form-item label="拍照时间">{{ detail.createTime }}</el-form-item>
        <el-form-item label="支付状态">{{ detail.payStatus === 0 ? '未支付' : (detail.payStatus === 1 ? '支付成功' : '免费') }}</el-form-item>
        <el-form-item label="订单ID">{{ detail.orderId || '-' }}</el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import listPage from '../../../mixins/listPage.js'
import { post } from '../../../../public/request/request.js'

export default {
  mixins: [listPage],
  data() {
    return {
      total: 0,
      channels: [],
      queryParams: { pageIndex: 1, pageSize: 10, channelId: '', deviceCode: '', idName: '', idNumber: '' },
      tableData: [],
      dialogVisible: false,
      detail: {}
    }
  },
  created() {
    this.loadChannels()
    this.GetData()
  },
  methods: {
    search() {
      this.queryParams.pageIndex = 1
      this.GetData()
    },
    loadChannels() {
      post(208, { channelName: '' }).then(response => {
        if (response.data.result == 0 && Array.isArray(response.data.data)) {
          this.channels = response.data.data
        }
      }).catch(() => {})
    },
    GetData() {
      const loading = this.openLoading()
      post(501, {
        pageIndex: this.queryParams.pageIndex,
        pageSize: this.queryParams.pageSize,
        channelId: this.queryParams.channelId || 0,
        deviceCode: (this.queryParams.deviceCode || '').trim(),
        idName: (this.queryParams.idName || '').trim(),
        idNumber: (this.queryParams.idNumber || '').trim()
      }).then(response => {
        loading.close()
        if (response.data.result == 0) {
          const data = response.data.data || {}
          this.tableData = Array.isArray(data.list) ? data.list : []
          this.total = Number(data.pageCount) || 0
        } else {
          this.tableData = []
          this.total = 0
          this.$message.error('查询失败：' + response.data.message)
        }
      }).catch(error => {
        loading.close()
        this.tableData = []
        this.total = 0
        this.$message.error((error && error.userMessage) || '查询失败')
      })
    },
    openDetail(row) {
      const loading = this.openLoading()
      post(502, { objId: row.id }).then(response => {
        loading.close()
        if (response.data.result == 0) {
          this.detail = response.data.data || row
          this.dialogVisible = true
        } else {
          this.$message.error('查询详情失败：' + response.data.message)
        }
      }).catch(error => {
        loading.close()
        this.$message.error((error && error.userMessage) || '查询详情失败')
      })
    }
  }
}
</script>
